import {AxiosRequestConfig} from 'axios';

import request from '../../axios';

interface IAdvertisementProps {
  filter: string;
}

const getAdvertisements = async (payload: IAdvertisementProps) => {
  const {data}: {data: Array<IMyAdvertismentData>} = await request.get(
    'api/v2/store/advertisement',
    {
      params: payload,
    } as AxiosRequestConfig,
  );

  return data;
};

export default getAdvertisements;
